var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.srclist),function(item,index){return _c('a',{attrs:{"href":("" + _vm.baseUrl + item),"underline":false,"target":"_blank"}},[_c('van-button',{attrs:{"plain":"","type":"primary"}},[_vm._v(_vm._s(_vm.getname(item)))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75fed272","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileDownload/index.vue
// module id = null
// module chunks = 